import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { debug, download, file, swalAlert } from '../../utils';
import API from '../../api';
import { useSelector } from 'react-redux';
import { FiChevronRight } from 'react-icons/fi'
import FormalitiesStatusCards from 'components/formalities/admin/helpers/FormalitiesStatusCards';
/*
import AdminOrdersChart from './../orders/admin/AdminOrdersChart';
import AdminHomeUpdate from '../products/admin/AdminHomeUpdate'
import QRCodeGenerator from '../products/admin/QRCodeGenerator';
*/
import { FaCircle } from 'react-icons/fa';
import './admin-home.css';
function HomeAdmin() {
  const { t } = useTranslation();
  return (
    <div id="admin-home" className='container-fluid'>
      <div className='py-3'></div>
      <div className='section'>
        <div className='d-flex justify-content-between align-items-end w-100 mb-4'>
          <div className='flex-grow-1'>
            <h1>
              <span>Etat des demandes de formalités</span>
            </h1>
          </div>
          <div className='text-end  '>
            <Link to="/admin/formalities/requests/list" className="decoration-on-hover text-primary">Voir toutes les demandes <FiChevronRight /></Link>
          </div>
        </div>
        <div className='container'>
          <FormalitiesStatusCards />
        </div>
      </div>
    </div >
  );
}
export default HomeAdmin;
